import { motion } from "framer-motion";
import bgShape1 from '../assets/images/bg/bgShape1';
import bgShape2 from '../assets/images/bg/bgShape2';
import decoOrange from '../assets/images/home/orange.svg'

const AnimatedBg = () => {
  const floatAnimation = {
    rotate: [0, 8, -6, 0],
    scale: [1, 1.07, 0.95, 1],
    y: [0, -10, 10, 0],
    opacity: [0.9, 1, 0.85, 1],
  };

  const floatTransition = (i) => ({
    duration: 12,
    ease: "easeInOut",
    repeat: Infinity,
    delay: i * 0.4,
  });
  
  const circleAnimation = {
    y: [0, -10, 0, 10, 0],
    transition: {
    duration: 8,
    ease: "easeInOut",
    repeat: Infinity,
    },
  };

  const circleAnimationDelayed = {
    ...circleAnimation,
    transition: {
        ...circleAnimation.transition,
        delay: 2
    },
  };

  return (
    <>
      <div id="fillTheGap-bg-decoL">
        {bgShape1.map((shape, i) => (
          <motion.img
            key={i}
            src={shape}
            alt={`shapeL-${i}`}
            animate={floatAnimation}
            transition={floatTransition(i)}
            className="decoL"
            style={{
              transformOrigin: "center",
              filter: "blur(0.5px)",
            }}
          />
        ))}
        <motion.img
          src={decoOrange}
          animate={circleAnimation}
          className="decoL-orange"
        />
      </div>

      <div id="fillTheGap-bg-decoR">
        {bgShape2.map((shape, i) => (
          <motion.img
            key={i}
            src={shape}
            alt={`shapeR-${i}`}
            animate={floatAnimation}
            transition={floatTransition(i)}
            className="decoR"
            style={{
              transformOrigin: "center",
              filter: "blur(0.5px)",
            }}
          />
        ))}
        <motion.img
          animate={circleAnimationDelayed}
          src={decoOrange}
          className="decoR-top-orange"
        />
        <motion.img
          animate={circleAnimation}
          src={decoOrange}
          className="decoR-bottom-orange"
        />
      </div>
    </>
  );
};

export default AnimatedBg;
